/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catalog_Movement_Vertical_PullInputs */

const en_us2_catalog_movement_vertical_pull = /** @type {(inputs: Catalog_Movement_Vertical_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vertical pull`)
};

const pt_br2_catalog_movement_vertical_pull = /** @type {(inputs: Catalog_Movement_Vertical_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`puxada vertical`)
};

const es_419_catalog_movement_vertical_pull = /** @type {(inputs: Catalog_Movement_Vertical_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jalón vertical`)
};

const pt_pt2_catalog_movement_vertical_pull = /** @type {(inputs: Catalog_Movement_Vertical_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`puxada vertical`)
};

const fr_fr2_catalog_movement_vertical_pull = /** @type {(inputs: Catalog_Movement_Vertical_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tirage vertical`)
};

const de_de2_catalog_movement_vertical_pull = /** @type {(inputs: Catalog_Movement_Vertical_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vertikales Ziehen`)
};

const it_it2_catalog_movement_vertical_pull = /** @type {(inputs: Catalog_Movement_Vertical_PullInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tirata verticale`)
};

/**
* | output |
* | --- |
* | "vertical pull" |
*
* @param {Catalog_Movement_Vertical_PullInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const catalog_movement_vertical_pull = /** @type {((inputs?: Catalog_Movement_Vertical_PullInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catalog_Movement_Vertical_PullInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_catalog_movement_vertical_pull(inputs)
	if (locale === "es-419") return es_419_catalog_movement_vertical_pull(inputs)
	if (locale === "pt-PT") return pt_pt2_catalog_movement_vertical_pull(inputs)
	if (locale === "fr-FR") return fr_fr2_catalog_movement_vertical_pull(inputs)
	if (locale === "de-DE") return de_de2_catalog_movement_vertical_pull(inputs)
	if (locale === "it-IT") return it_it2_catalog_movement_vertical_pull(inputs)
	return en_us2_catalog_movement_vertical_pull(inputs)
});
export { catalog_movement_vertical_pull as "catalog.movement.vertical_pull" }